// 0BC67f26f95DCD902066b8E62b067Bd859A1C922
import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Switch,
  Image,
  List,
  Upload,
} from "antd";
import {
  LoadingOutlined,
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { TbNotes } from "react-icons/tb";

import Swal from "sweetalert2";
import moment from "moment";

import { useSelector, useDispatch } from "react-redux";
import { shippingActions } from "../../store";
import shippingApi from "../../api/shippingApi";
import PERMISSION from "../../consts/permissions";

const Shipping = (props) => {
  const dispatch = useDispatch();
  const { lstShipping, isCreate, notes, key } = useSelector((x) => x.shipping);
  const { permissions } = useSelector((x) => x.auth);
  const [listPermissions, setPermissions] = useState(permissions);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const dateFormat = "DD/MM/YYYY HH:mm:ss";
  const [form] = Form.useForm();
  const [form2] = Form.useForm();

  const [isEditModal, setEditModal] = useState(false);
  const [isShowModalNote, setShowModalNote] = useState(false);

  const [valueForm, setValueForm] = useState();
  const [valueNote, setValueNote] = useState();

  useEffect(() => {
    getShipping();
    form.setFieldsValue(valueForm);
  }, [valueForm, isEditModal]);

  const getShipping = () => {
    setLoading(true);
    dispatch(shippingActions.getShipping()).then(() => {
      setLoading(false);
    });
  };

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Logo",
      dataIndex: "logo",
      key: "logo",
      render: (avatar) => (
        <>
          {avatar && <Image width={100} src={avatar} alt="Logo" />}
          {!avatar && (
            <Image
              width={100}
              src="error"
              fallback="data:image/png;base64,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"
              alt=" Logo"
            />
          )}
        </>
      ),
      width: 350,
      className: "text-center",
    },
    {
      title: "Tên nhà vận chuyển",
      dataIndex: "name",
      render: (text) => <h6>{text}</h6>,
    },
    {
      title: "Mô tả",
      dataIndex: "description",
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      render: (createdAt) => <>{moment(createdAt).format(dateFormat)} </>,
    },
    {
      title: "Ngày sửa",
      dataIndex: "createdAt",
      render: (updatedAt) => <>{moment(updatedAt).format(dateFormat)} </>,
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      render: (active) => (
        <>
          {active === true && (
            <Tag color="green" key={active}>
              Hoạt động
            </Tag>
          )}
          {active === false && (
            <Tag color="red" key={active}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {listPermissions.includes(PERMISSION.Admin_Shipping_Update) ? (
            <>
              <Button
                onClick={() => showEditModal(record)}
                value="large"
                icon={<EditOutlined />}
              >
                Sửa
              </Button>
            </>
          ) : null}
        </Space>
      ),
      width: 150,
      className: "text-center",
      fixed: "right",
    },
  ];

  const showEditModal = (record) => {
    setValueForm({
      key: record.key,
      logo: record.logo,
      name: record.name,
      description: record.description,
      token: record.token,
      active: record.active,
    });
    setImageUrl(record.logo);
    setEditModal(true);
  };

  const updateShipping = (data) => {
    const payload = {
      key: data.key,
      active: data.active,
      name: data.name,
      description: data.description,
      token: data.token,
    };

    shippingApi.updateShipping(payload).then(
      (res) => {
        if (res == "OK") {
          Swal.fire({
            title: "Thành Công!",
            text: "Cập nhật thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setEditModal(false);
          getShipping();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const closePopup = useCallback(() => {
    setValueForm();
    form.resetFields();
    setEditModal(false);
  }, [form]);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = useCallback((values) => {
    updateShipping(values);
  }, []);

  const onSaveNote = useCallback(() => {
    createNote(valueNote);
  }, [valueNote]);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }

    return isJpgOrPng && isLt2M;
  };

  const [imageUrl, setImageUrl] = useState();

  const handleChange = (info) => {
    if (info.file.active === "uploading") {
      setLoading(true);
      return;
    }

    if (info.file.active === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };

  const normFile = (e) => {
    console.log("Upload event:", e);

    if (Array.isArray(e)) {
      return e;
    }

    return e?.fileList;
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  const closePopupNote = useCallback(() => {
    setShowModalNote(false);
    setValueNote({});
  }, []);

  const createNote = (value) => {
    const data = {
      content: value,
      key: key,
    };

    shippingApi.createNote(data).then(
      (res) => {
        // console.log("res", res);
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo ghi chú thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          getShipping();
          form2.resetFields();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const confirm = Modal.confirm;

  const deleteNote = (id) => {
    const data = {
      key: key,
      ids: [id],
    };
    console.log(data);
    confirm({
      title: "Bạn có muốn xóa ghi chú này không?",
      onOk() {
        shippingApi
          .deleteNote(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công");
              getShipping();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  return (
    <>
      <div className="tabled">
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          // title="Quản lý nhà vận chuyển"
        >
          <div className="table-responsive">
            <Table
              rowKey={(record) => record.key}
              loading={loading}
              columns={columns}
              dataSource={lstShipping}
              bordered
              className="ant-border-space"
            />
          </div>
        </Card>

        <Modal
          forceRender
          title="Chỉnh sửa"
          visible={isEditModal}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
        >
          <div>
            <Form
              form={form}
              initialValues={valueForm}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item hidden={true} label="key" name="key">
                <Input />
              </Form.Item>

              <Form.Item
                label="Tên nhà vận chuyển"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please input name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item label="Mô tả" name="description">
                <Input />
              </Form.Item>

              <Row gutter={16}>
                <Space size={5}>
                  <Col>
                    <Form.Item
                      label="Token"
                      name="token"
                      rules={[
                        {
                          required: true,
                          message: "Please input token!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  {isCreate ? (
                    <Col>
                      <Form.Item label="Ghi Chú" name="isCreate">
                        <Button
                          icon={<TbNotes />}
                          onClick={() => setShowModalNote(true)}
                        >
                          &nbsp; Sửa ghi chú
                        </Button>
                      </Form.Item>
                    </Col>
                  ) : null}
                </Space>
              </Row>

              <Form.Item
                label="Trạng thái"
                valuePropName="checked"
                name="active"
              >
                <Switch />
              </Form.Item>

              <Form.Item
                label="Logo nhà vận chuyển "
                name="logo"
                // valuePropName="fileList"
                //   getValueFromEvent={normFile}
              >
                <Upload
                  name="logo"
                  listType="picture-card"
                  className="avatar-uploader mt-5"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="logo"
                      style={{
                        width: "100%",
                      }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </Form.Item>
            </Form>
          </div>
        </Modal>

        <Modal
          forceRender
          title="Sửa ghi chú"
          visible={isShowModalNote}
          onOk={() => {
            closePopupNote();
          }}
          onCancel={() => {
            closePopupNote();
          }}
        >
          <div>
            <Form
              name="basic"
              layout="vertical"
              autoComplete="off"
              form={form2}
            >
              <Form.Item label="" name="note">
                <Row>
                  <Col span={18}>
                    <Input
                      onChange={(e) => {
                        setValueNote(e.target.value);
                      }}
                      maxLength={120}
                    />
                  </Col>
                  <Col span={6}>
                    <Button onClick={onSaveNote}>Thêm ghi chú</Button>
                  </Col>
                </Row>
              </Form.Item>
              <label>Ghi chú đơn hàng</label>
              <br /> <br />
              <List
                size="small"
                bordered
                dataSource={notes}
                renderItem={(item) => (
                  <List.Item>
                    <Col>{item.content}</Col>
                    <Col>
                      <Button
                        value="small"
                        type="primary"
                        icon={<DeleteOutlined />}
                        danger
                        onClick={() => {
                          deleteNote(item.id);
                        }}
                      >
                        Xóa
                      </Button>
                    </Col>
                  </List.Item>
                )}
              />
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Shipping;
